<link rel="preconnect" href="https://fonts.googleapis.com" />
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link
    href="https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap"
    rel="stylesheet" />

<div class="login-overlay">
    <div class="login-container">
        <aside class="left-popup-login">
            <div class="background-video">
                <img src="assets/register-login/login-img.jpg" alt="Logo" class="login-logo" />
            </div>
        </aside>
        <div class="main-container right-side-login">
            <header>
                <div class="help-btn-container">
                    <a href="https://betimpact.tawk.help" target="_blank">
                        <button class="help-btn">
                            <span>{{ 'register_modal.need_help' | transloco }}</span>
                            <img src="assets/register-login/chat.svg" width="25" height="25" />
                        </button>
                    </a>
                </div>
                <div class="register-link"></div>
                <button class="close-login" (click)="onClose()">
                    <img src="assets/header-icons/close.svg" />
                </button>
            </header>
            <div class="register-main-container">
                <div class="form-container">
                    <div class="form-track-container">
                        <div class="inner-container">
                            <form class="combined-form" [formGroup]="formGroup">
                                <div>
                                    <div class="forgot-pass-main">
                                        <span class="forgot-span-text">
                                            {{ 'reset_password_modal.create_new_password' | transloco }}
                                        </span>
                                        <br />
                                        <span class="forgot-p-text">
                                            {{ 'reset_password_modal.after_reset_password' | transloco }}
                                        </span>
                                    </div>
                                    <div class="input-container">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <label for="password" class="register-label">
                                                <span>
                                                    {{ 'user_profile.login_security.new_password' | transloco }}
                                                </span>
                                            </label>
                                            <img src="../../../assets/images/profile/eye.svg" class="icon-eye"
                                                (click)="toggleShowPassword()" />
                                        </div>

                                        <input formControlName="password" id="password" placeholder=" "
                                            [type]="passwordType()" class="input-field" />

                                        <span class="password-req">
                                            <img [src]="
                                                    !formGroup
                                                        .get('password')
                                                        ?.hasError('invalidPassword')
                                                        ? 'assets/images/transactions/transaction-status/ACCEPTED.svg'
                                                        : 'assets/register-login/password-x.svg'
                                                " width="12" height="12" />
                                            <span>
                                                {{ 'register_modal.password_validation' | transloco }}
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                @if (errorMessage()) {
                                <div class="text-danger">
                                    <small>{{ errorMessage() }}</small>
                                </div>
                                }
                                <div class="button-container">
                                    <button class="next-button" (click)="onSubmit()" [disabled]="!formGroup.valid">
                                        <span>
                                            {{ 'login_modal.button_next' | transloco }}
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>